"use strict";
// Copyright (c) StrangeBee 2024
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ParentController_1 = __importDefault(require("../ParentController"));
class CaseTemplateController extends ParentController_1.default {
    constructor() {
        super(...arguments);
        this.endpoints = {
            create: '/v1/caseTemplate',
            edit: '/v1/caseTemplate/:objectId',
            linkPageTemplates: '/v1/caseTemplate/:caseTemplateId/pageTemplate/link',
            delete: '/v1/caseTemplate/:objectId',
        };
    }
    linkPageTemplates(pageTemplateIds, caseTemplateId) {
        return this.manager.put({
            url: this.endpoints.linkPageTemplates,
            params: { caseTemplateId },
        }, {
            pageTemplateIds,
        });
    }
}
exports.default = CaseTemplateController;
